/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import Section from '../components/Section/Section'
import withCongress, { ComponentProps } from '../providers/Congress/withCongress'
import Content from '../components/Layout/Content'
import { RouteComponentProps } from 'react-router'
import Button from '../components/Utils/Button'
import { getNextWizardPath } from '../helpers/wizard'
import Form from 'react-trazo-forms'
import { activationFields, activationInitialValues, activationValidationSchema, } from '../forms/activation/activation'
import { Trans } from '@lingui/macro'
import styled from 'styled-components'
import { color, ColorProps, fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'
import { getEmbedParam, getSegmentUUIDParam } from '../helpers/layout'
import { createReservation, getSegment, getDefaultSegment } from '../requests/inscription'
import { Modal, Button as Btn } from 'antd'
import { i18n } from '../providers/Locale/localeProvider'
import Col from '../components/Form/Col'
import Row from '../components/Form/Row'
import withURLParams, { URLParamsComponentProps } from '../providers/URLParams/withURLParams'
import { flowRight } from 'lodash'
import {Request} from 'fetchboi'
import { formsURL } from '../config/index.config'
import { Checkbox } from 'antd'

interface State {
  values: any,
  isValid: boolean,
  isLoading: boolean,
  isEmbed: boolean,
  segment: any,
  isOpen: boolean,
  defaultSegment: any,
  isTermsAccepted: any,
}

class Activation extends React.Component<ComponentProps & RouteComponentProps & URLParamsComponentProps, State> {
  state: State = {
    values: {},
    isValid: false,
    isLoading: false,
    isEmbed: false,
    segment: null,
    isOpen: false,
    defaultSegment: {},
    isTermsAccepted: false
  }

  async componentWillMount () {
    const { congress } = this.props
    const { defaultSegment } = this.state
    var segmentUUID = getSegmentUUIDParam()

    try {
      const defaultSegmentData = await getDefaultSegment({ congressSlug: congress.Slug })
      await this.setState({ defaultSegment : defaultSegmentData.Data[0] })
    }catch(e){
      console.log('ocurrió un error obteniendo el segmento default: ',e)
    }

    if(segmentUUID){
      try {
        const checkSegment = await getSegment({ CongressSlug: congress.Slug, uuid: segmentUUID})
        if(checkSegment.Data.length === 0){
         this.setState({ isOpen: true })
        }
      } catch(e) {
       this.setState({ isOpen: true })
      }
    }else {
     segmentUUID = defaultSegment.UUID
    }

    this.setState({
      isEmbed: getEmbedParam() !== null,
      segment: segmentUUID
    })
  }

  onChange = (e: any) => {
    console.log(`checked = ${e.target.checked}`)
    this.setState({ isTermsAccepted: e.target.checked})
  }

  handleFormSubmit = () => {
    const { congress, history, params } = this.props
    const { values: _values, segment } = this.state

    const values: any = { ..._values, CongressSlug: congress.Slug }

    if (params.referral) {
      values.PeerReferralCode = params.referral
    }

    this.setState({ isLoading: true })

    console.log(Request.defaultParams)

    createReservation(null, {
      ...values,
      StartingSource: 'forms',
      SegmentUUID: segment,
    })
      .then((resp: any) => {
        console.log('data', resp)
        const id = resp.Data.ID || resp.Data.UUID
        if (resp.Data.IsPhaseOneCompleted) {
          history.push(getNextWizardPath(id, congress.Slug, 'information'))
        } else {
          history.push(getNextWizardPath(id, congress.Slug))
        }
      })
      .catch(this.handleError)
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleError = (resp: any) => {
    const duplicateRegex = /(duplicate key value)/gm
    const confirmedRegex = /(already confirmed)/gm

    let message = resp.message

    if(message.substr(0, 20) === 'uuid: incorrect UUID'){
      this.setState({ isOpen: true })
      return
    }

    if (duplicateRegex.exec(resp.message)) {
      message = i18n._('El correo electrónico ya fue registrado')
    } else {
      if (confirmedRegex.exec(resp.message)) {
        message = i18n._('El correo electrónico ya fue registrado')
        this.showInfoModal(i18n._('Inscripción ya confirmada'), message)
        return
      }
    }

    this.showInfoModal(i18n._('Tuvimos un problema'), message)
  }

  showInfoModal = (title: string, message: string) => {
    Modal.info({
      title: title,
      content: (
        <div>
          <p>{message}</p>
        </div>
      ),
    })
  }

  handleOk = () => {
    const { congress } = this.props
    const { defaultSegment } = this.state

    window.open(formsURL+'/'+congress.Slug+'?Segment='+defaultSegment.UUID , '_blank')
    this.setState({ isOpen: false, values: {} })
  }

  render () {
    const { isLoading, isEmbed } = this.state
    const { congress, params } = this.props

    const initialEmail = params.email || ''

    return (
      <Content isLoading={isLoading}>
        <Heading color="black" fontSize={[2, 3]} mb={0}>
          <Trans>Ingrese sus datos <strong>personales</strong> para inscribirse</Trans>
        </Heading>

        {congress.Slug === 'expoedifica2019' && (
          <SubHeading color="black" fontSize={[0, 1]} mb={0}>
            <Trans>La inscripción tiene un valor de <strong>CLP$7.000</strong></Trans>
          </SubHeading>
        )}

        <Section>
          <Form
            initialValues={activationInitialValues({ Email: initialEmail })}
            fields={activationFields()}
            validationSchema={activationValidationSchema}
            onChange={(values, isValid) => this.setState({ values, isValid })}
            onSubmit={this.handleFormSubmit}
            isLoading={isLoading}
          >
            {() => (
              <React.Fragment>
                <Row gutter={32} m={0} justify="center">
                  <Col md={10}>
                    <Form.Field name="FirstName"/>
                  </Col>
                  <Col md={10}>
                    <Form.Field name="LastName"/>
                  </Col>
                </Row>
                <Row gutter={32} m={0} justify="center">
                  <Col md={10}>
                    <Form.Field name="Email"/>
                  </Col>
                  <Col md={10}>
                    <span>
                      <Trans>Debe ingresar una dirección de email válida y sin espacios. Será necesario validar su correo electrónico para poder asistir al evento y utilizar la aplicación móvil.</Trans>
                    </span>
                  </Col>
                </Row>
                <Row gutter={32} m={0} justify="center">
                  <Col md={10} >
                    <CheckBoxSection>
                      <Checkbox onChange={this.onChange}>
                        <i style={{ color: '#999999' }}>
                          <Trans>He leído y acepto los 
                            <PoliciesLink href="https://policies.trazolabs.com/congresos">Términos y Condiciones</PoliciesLink>
                          </Trans>
                        </i>
                      </Checkbox>
                    </CheckBoxSection>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </Form>
        </Section>

        <div style={{ marginTop: 16, marginBottom: 16, }}>
          <Section align="center" showBorder={false}>
            {this.renderActionButton()}
          </Section>
        </div>

        <Section align="center" showBorder={false}>
          <i style={{ color: '#999999' }}>
            <Trans>Al continuar acepta nuestro uso de Cookies para mejorar su experiencia de usuario.</Trans>
          </i>
        </Section>
        {this.renderModal()}
      </Content>
    )
  }

  renderModal () {
    const { defaultSegment } = this.state
    return (
      <div>
        <Modal
          title="Ocurrió un problema"
          visible={this.state.isOpen}
          onOk={this.handleOk}
          onCancel={() => this.setState({ isOpen: false })}
          footer={[
            <Btn key="back" onClick={() => this.setState({ isOpen: false })}>
              Volver
            </Btn>,
            <Btn key="submit" type="primary" onClick={this.handleOk}>
              Registrarse como { defaultSegment ? defaultSegment.Name : "Anonimo"}
            </Btn>,
          ]}
        >
          <p>El enlace no parece estar correcto. Si deseas completar el formulario de inscripción de { defaultSegment ? defaultSegment.Name : "Anonimo"},
             presione en botón <strong>Registrarse como { defaultSegment ? defaultSegment.Name : "Anonimo"}</strong>. En caso contrario, verifique que el enlace utilizado es el correcto o
            comuniquese con la organización del evento.</p>
        </Modal>
      </div>
    )
  }

  renderActionButton () {
    const { isValid, isLoading, isTermsAccepted } = this.state
    const { congress } = this.props

    let message = 'Algunas respuestas son inválidas o no están completas'

    if (!isTermsAccepted) {
      message = 'Debe aceptar los términos y condiciones'
    }

    return (
      <Button
        disabledMessage={i18n._(message)}
        color={congress.PrimaryColor}
        disabled={!isValid || isLoading || !isTermsAccepted}
        onClick={this.handleFormSubmit}>
        <Trans>¡Reserve su Cupo!</Trans>
      </Button>
    )
  }
}

const CheckBoxSection = styled.div`
  margin-bottom: 24px;
  margin-top: 12px;
  justify-items: left;
  width:full
`
const Heading = styled.h1<ColorProps & FontSizeProps & SpaceProps>`
  text-align: center;

  ${color}
  ${space}
  ${fontSize}
`

const SubHeading = styled.h2<ColorProps & FontSizeProps & SpaceProps>`
  text-align: center;

  ${color}
  ${space}
  ${fontSize}
`

const Banner = styled.img<SpaceProps & any>`
  width: 100%;
  border-radius: 5px;

  ${({ hidden }) => hidden && 'display: none;'}

  ${space}
`

const PoliciesLink = styled.a`
  color: #666666
`

export default flowRight([withCongress, withURLParams])(Activation)
